module.exports = __webpack_public_path__ + "img/ibc-international-bio-cosmetics-conseil-experts-huile-de-sesame.e4a3e4e4.jpg";